// state
import axios from "axios";
import commonservice from "../../../shared/common.service";

const defaultState = () => ({
  id: null,
  name: null,
  sort: null,
  showInMenu: false,
  description: null,
  keywords: null,
  url: null,
  shortDescription: null,
  displayName: null,
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  loadCategory({}, { pagination, search }) {
    return new Promise((resolve, reject) => {
      var param = {
        descending:
          pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
        page: pagination.page,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
        search: search,
      };
      axios
        .get("/category?" + commonservice.convertToQueryString(param))
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setCategory({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/category/" + id)
        .then((response) => {
          commit("SET_CATEGORY", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveCategory({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.id) {
        axios
          .patch("/category", state)
          .then((response) => {
            commit("RESET");
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        axios
          .post("/category", state)
          .then((response) => {
            commit("RESET");
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  },
  deleteCategory({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/category/" + id)
        .then((response) => {
          commit("RESET");
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

// mutations
const mutations = {
  RESET(state) {
    Object.assign(state, defaultState());
  },
  SET_CATEGORY_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state[data.key] = data.value;
  },
  SET_CATEGORY(state, data) {
    state.id = data.id;
    state.name = data.name;
    state.sort = data.sort;
    state.showInMenu = data.showInMenu;
    state.shortDescription = data.shortDescription;
    state.description = data.description;
    state.keywords = data.keywords;
    state.url = data.url;
    state.displayName = data.displayName;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
